import React from "react";
import PropTypes from "prop-types";

/**
 * One labelled row of a wizard form: the label in a column of its own from
 * `sm` up, so a stack of rows lines its inputs up, and above the input on a
 * phone, where there is no room beside it.
 *
 * `label` may carry markup (an "(optional)" hint, an InfoTip) — it is rendered
 * inside the <label> only when it is plain, so a tooltip button never ends up
 * nested in a label that would forward its clicks to the input.
 */
const FormRow = ({ htmlFor, label, info, children, labelAs = "label" }) => {
  const Label = labelAs;
  return (
    <div className="grid gap-1.5 sm:grid-cols-[11rem_minmax(0,1fr)] sm:items-start sm:gap-4">
      <div className="flex min-w-0 items-center gap-1.5 sm:min-h-11">
        <Label
          htmlFor={labelAs === "label" ? htmlFor : undefined}
          className="text-sm font-semibold text-ink-700"
        >
          {label}
        </Label>
        {info}
      </div>
      <div className="min-w-0">{children}</div>
    </div>
  );
};

FormRow.propTypes = {
  htmlFor: PropTypes.string,
  label: PropTypes.node.isRequired,
  info: PropTypes.node,
  children: PropTypes.node,
  /** "span" for a row whose control is a group of buttons, not one input. */
  labelAs: PropTypes.oneOf(["label", "span"]),
};

export default FormRow;
